import React, { useState } from 'react'
import "react-responsive-modal/styles.css";
import styles from "./modalChangePassword.module.css";
import { Modal } from "react-responsive-modal";
import Header from '../Header/Header';
import { ToastContainer, toast } from "react-toastify";
import { Button, TextInput, Pane, EyeOpenIcon, EyeOffIcon, InfoSignIcon, Tooltip, Position } from 'evergreen-ui';
import { validatePassword } from "../../Utils/Validation";
export const ModalChangePassword = ({
  open,
  onOpenModal,
  onCloseModal,
  userId
}) => {
  const [btnLoading, setbtnLoading] = useState(false);
  const [resetPassword, setResetPassword] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: ""
  })
  const [showPassword, setShowPassword] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };
  const handleResetPassword = (e) => {
    const { name, value } = e.target;
    setResetPassword({
      ...resetPassword,
      [name]: value.replace(/^\s+|\s+$/g, "") ,
    });
  }
  const handlePasswordChange = (e) => {
    e.preventDefault();
    setbtnLoading(true);
    const payload = {
      old_password: resetPassword.oldPassword,
      new_password: resetPassword.newPassword,
      confirm_new_password: resetPassword.confirmPassword,
      vendor_id: userId
    };
    if (resetPassword.oldPassword == "") {
      toast.error("Old Password field is required");
      setbtnLoading(false);
    }else if (resetPassword.newPassword == "" && resetPassword.confirmPassword == "") {
      toast.error("New Password field  and Confirm Password field is required");
      setbtnLoading(false);
    }
    else if (resetPassword.newPassword == "") {
      toast.error("New Password field is required");
      setbtnLoading(false);
    } else if (resetPassword.confirmPassword == "") {
      toast.error("Confirm Password field is required");
      setbtnLoading(false);
    } 
    else if(resetPassword.newPassword != resetPassword.confirmPassword){
      toast.error("New Password and Confirm Password does not match");
      setbtnLoading(false);
    }
    else if (!validatePassword(resetPassword.newPassword).valid) {
      toast.error(validatePassword(resetPassword.newPassword).error);
      setbtnLoading(false);
    }else {
      fetch(process.env.REACT_APP_API_URL + "/api/vendor/password_change", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "content-type": "application/json" },
      })
        .then((d) => d.json())
        .then((res) => {
          setbtnLoading(false);

          if (res.status === true) {
            toast(`${res.message}`, {
              type: "success",
            });
            setResetPassword({
              oldPassword: "",
              newPassword: "",
              confirmPassword: ""
            });
            onCloseModal();
          } else {
            toast(`${res.message}`, {
              type: "error",
            });
            setResetPassword({
              oldPassword: "",
              newPassword: "",
              confirmPassword: ""
            });
          }
        })
        .catch((err) => {
          console.log("e", err);
        });
    }
  }
  return (
    <div>
      <Modal open={open} showCloseIcon={false} onClose={onCloseModal} center>
        <div>
          <Header title={"Change Password"} customMg={"13px"} />
          <div className={styles.resetPasswordMain}>
            <div>
              <label htmlFor="" className={styles.LLabel}>
                OLD PASSWORD
              </label>
              <br />
              <TextInput
                type="password"
                className={styles.mgbottominputSB}
                width={300}
                height={40}
                placeholder="Enter Old Password"
                name="oldPassword"
                value={resetPassword.oldPassword}
                onChange={handleResetPassword}
                required
              />
            </div>
            <div>
              <label htmlFor="" className={styles.LLabel}>
                New Password
                {
                    <Tooltip
                      content="The new password must be at least 8 characters long and include at least one uppercase letter, one number, and one special character (@$!%*?&). Avoid sequential patterns (like 1234 or abcd) and repeated characters (like 111 or aaa)."
                      position={Position.RIGHT}
                      appearance="card"
                      >
                      <span className={styles.tooltipspan}>
                        <InfoSignIcon icon="info-sign" color="primary" size={14} />
                      </span>
                    </Tooltip>
                }
              </label>
              <br />
              <Pane className={styles.panecls}>
              <TextInput
                type={showPassword.newPassword ?"text":"password"}
                className={styles.mgbottominputSB}
                width={300}
                height={40}
                placeholder="Enter New Password"
                name="newPassword"
                value={resetPassword.newPassword}
                onChange={handleResetPassword}
                required
              />
              {showPassword.newPassword ? (
                  <EyeOpenIcon
                    className={styles.eyecommon}
                    onClick={() => togglePasswordVisibility("newPassword")}
                  />
              ) : (
                <EyeOffIcon
                  className={styles.eyecommon}
                  onClick={() => togglePasswordVisibility("newPassword")}
                />
              )}
              </Pane>
            </div>
            <div>
              <label htmlFor="" className={styles.LLabel}>
                CONFIRM PASSWORD
              </label>
              <br />
              <Pane className={styles.panecls}>
              <TextInput
                type={showPassword.confirmPassword ?"text":"password"}
                className={styles.mgbottominputSB}
                width={300}
                height={40}
                placeholder="Enter Confirm Password"
                name="confirmPassword"
                value={resetPassword.confirmPassword}
                onChange={handleResetPassword}
                required
              />
               {showPassword.confirmPassword ? (
                  <EyeOpenIcon
                    className={styles.eyecommon}
                    onClick={() => togglePasswordVisibility("confirmPassword")}
                  />
              ) : (
                <EyeOffIcon
                  className={styles.eyecommon}
                  onClick={() => togglePasswordVisibility("confirmPassword")}
                />
              )}
              </Pane>
            </div>
            <div className={styles.btnDiv}>
              <Button
                className={styles.submitBtnPO}
                id="poppinFont"
                marginRight={16}
                // isLoading={btnLoading}
                disabled={btnLoading}
                onClick={handlePasswordChange}
              >
                {btnLoading && (
                  <i
                    className="fa fa-spinner fa-spin "
                    style={{ color: "white", marginRight: "10px" }}
                  ></i>
                )}
                Change Password
              </Button>
              <Button
                className="poppinFont"
                marginRight={16}
                onClick={() => onCloseModal()}
              >
                Cancel
              </Button>
            </div>
          </div>

        </div>
      </Modal>
      {/* <ToastContainer autoClose={false} /> */}
    </div>
  )
}
